export const DS_PINS_COUNT_STATUS_ID = 7;
